import { Injectable } from '@angular/core';

@Injectable()
export class NavbarService {
  visible: boolean;

  constructor() { this.visible = false; }

  hideGet() { return this.visible}
  hideSet(x: boolean) { this.visible = x}

  show() { this.visible = false; }

  toggle() { this.visible = !this.visible; }
}